export const getFontSize = (size: string): number => {
	switch (size) {
		case "extra-small":
			return 10;
		case "caption":
			return 12;
		case "paragraph-3":
			return 14;
		case "paragraph-2":
			return 16;
		case "paragraph-1":
			return 18;
		case "sub-heading":
			return 20;
		case "heading-5":
			return 24;
		case "heading-4":
			return 28;
		case "heading-3":
			return 32;
		case "heading-2":
			return 40;
		case "heading-1":
			return 48;
		default:
			return 14;
	}
};

export const getFontWeight = (weight: string): number => {
	switch (weight) {
		case "light":
			return 300;
		case "regular":
			return 400;
		case "semi-bold":
			return 600;
		case "bold":
			return 700;
		case "black":
			return 900;
		default:
			return 400;
	}
};
